import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, throwError } from 'rxjs';
import { catchError, exhaustMap, take } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return this.authService.authUser.pipe(
      take(1),
      exhaustMap(user => {
        if (!user) {
          return next.handle(request);
        }
        const modifiedReq = request.clone({
          headers: request.headers.set('authorization', `Bearer ${this.authService.accessToken}`)
        });
        return next.handle(modifiedReq);
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.authService.logout();
          return EMPTY;
        }
        return throwError(err);
      })
    );
  }
}
